import React, { useEffect } from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";

import { useRouteMatch, useHistory } from "react-router-dom";
import {
  initPatientDetailsPage,
  cleanUpCurrentPatientInfo,
} from "store/PatientStore/actions";
import { USER_GROUPS } from "constants/roles";
import { AthleteVideoExamTable } from "./containers/Athlete/AthleteVideoExamTable";
import { PatientVideoExamTable } from "./containers/Patient/PatientVideoExamTable";
import { PatientInfoContainer } from "./containers/Patient/PatientInfoContainer";
import { AthleteInfoContainer } from "./containers/Athlete/AthleteInfoContainer";
import { PatientRegionDetails } from "./containers/Patient/PatientRegionDetails";
import { AthleteRegionDetails } from "./containers/Athlete/AthleteRegionDetails";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { useAppSelector, useAppDispatch } from "hooks/reduxHooks";

export const PatientDetails = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const match = useRouteMatch<{ id: string }>();
  const isFromCronJob = window.location.search.includes("fromCronJob=true");
  const isFreeForm = window.location.search.includes("freeForm=true");
  const currentClinician = useAppSelector(selectCurrentClinician);

  useEffect(() => {
    dispatch(initPatientDetailsPage(match.params.id));
    return function cleanup() {
      dispatch(cleanUpCurrentPatientInfo());
    };
  }, [match.params.id]);
  const isSuperAdmin = currentClinician?.role?.includes(
    USER_GROUPS.SUPER_ADMIN
  );
  return (
    <div className="container max-w-[90%] m-auto px-8 pt-[30px]">
      <div className="mb-6">
        <button
          onClick={() => {
            if (window.location.search.includes("from=leaderboard")) {
              history.push("/report/leaderboard");
              return;
            }
            history.push("/");
          }}
          className="flex items-center gap-1 px-4 py-2 bg-sky-400 hover:bg-sky-500 text-white rounded-lg transition-colors"
        >
          <ArrowBack className="w-4 h-4" />
          <span>Back</span>
        </button>
      </div>
      {isSuperAdmin ? (
        <>
          <PatientRegionDetails
            isFromCronJob={isFromCronJob}
            patientId={match.params.id}
          />
        </>
      ) : (
        <>
          {(currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
            currentClinician?.role?.includes(
              USER_GROUPS.CLINIC_TEAM_MEMBER
            )) && (
            <>
              <PatientInfoContainer />
              <PatientRegionDetails
                isFromCronJob={isFromCronJob}
                patientId={match.params.id}
              />
            </>
          )}

          {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
            <>
              <AthleteInfoContainer />
              {!isFreeForm && <AthleteRegionDetails />}
            </>
          )}

          <div className="w-full card mt-5 rounded-[20px] px-4 pb-7 pt-4">
            <h2 className="text-xl ml-4">Video Exams</h2>
            {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
              <AthleteVideoExamTable isFreeForm={isFreeForm} />
            )}
            {(currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
              currentClinician?.role?.includes(
                USER_GROUPS.CLINIC_TEAM_MEMBER
              )) && <PatientVideoExamTable />}
          </div>
        </>
      )}
    </div>
  );
};
